import { useEffect } from 'react'
import { FormControlLabel, Switch } from '@mui/material'
import { useFormikContext } from 'formik'

import { IImpactForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  isMeasurable: boolean
  handleMeasurableUpdate: (value: boolean) => void
  disabled?: boolean
}

export const IsMeasurableCheckbox = ({
  isMeasurable,
  handleMeasurableUpdate,
  disabled,
}: IProps) => {
  const { validateField } = useFormikContext<IImpactForm>()

  useEffect(() => {
    validateField('quantity')
    validateField('quantity_type')
    validateField('period')
    validateField('period_start')
  }, [isMeasurable, validateField])

  const handleChange = (e: any, value: boolean) => {
    handleMeasurableUpdate(value)
  }

  return (
    <FormControlLabel
      disabled={disabled}
      control={
        <Switch
          checked={isMeasurable}
          name="isMeasurable"
          onChange={handleChange}
          color="primary"
        />
      }
      label={<HelperWrapper t="impacts-form-measurable-checkbox-label" isColorInherited />}
    />
  )
}
